<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6-desktop is-paddingless is-marginless">
            <h1 id="app-name" class="title is-size-1 has-text-weight-bold">Loud.</h1>
            <h1 class="title is-size-2-desktop is-size-3-mobile has-text-weight-light has-text-grey-dark">Welcome back,</h1>
            <h2 class="subtitle is-size-3-desktop is-size-4-mobile has-text-grey-lighter has-text-weight-light">Login to continue</h2>

            <form v-on:submit.prevent="submit">
              <div class="field">
                <label class="label is-medium has-text-weight-normal has-text-grey-dark" for="username">Username</label>
                <div class="control">
                  <input id="username" v-model="username" v-bind:class="{ 'is-danger': errors.username }" type="text" name="username" placeholder="Username" class="input is-medium" required>
                </div>
                <p v-if="errors.username" class="help is-danger">
                  {{ errors.username }}
                </p>
              </div>

              <div class="field">
                <label class="label is-medium has-text-weight-normal has-text-grey-dark" for="password">Password</label>
                <div class="control">
                  <input id="password" v-model="password" v-bind:class="{ 'is-danger': errors.password }" type="password" name="password" placeholder="Password" class="input is-medium" required>
                </div>
                <p v-if="errors.password" class="help is-danger">
                  {{ errors.password }}
                </p>
              </div>

              <div class="control poly-mt-1">
                <input type="submit" value="Login" class="button is-medium is-primary">
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { onLogin } from '@/vue-apollo'

  const ONLOGIN_REDIRECT_PATH = '/albums'

  export default {
    name: 'Login',
    data: function () {
      return {
        username: "",
        password: "",
        errors: {}
      }
    },
    methods: {
      submit: function (e) {
        this.$apollo.mutate({
          mutation: require('@/graphql/mutations/GenerateToken.gql'),
          variables: {
            username: this.username,
            password: this.password
          }
        }).then((result) => {
          const token = result.data.generateToken.token
          const apolloClient = this.$apollo.provider.defaultClient

          onLogin(apolloClient, token).then(() =>
            this.$router.push(this.$route.query.redirect || ONLOGIN_REDIRECT_PATH)
          )
        }).catch((error) => {
          this.errors = {}

          error.graphQLErrors.forEach(error =>
            this.errors[error.field] = error.message
          )
        })
      }
    }
  }
</script>

<style lang="scss">
  @import "~bulma/sass/utilities/initial-variables";
  @import "~bulma/sass/utilities/functions";

  #app-name {
    font-family: "Righteous", cursive;
    font-size: 4.2rem !important;
    margin-bottom: 3.0rem;
  }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    #app-name {
      font-size: 3.2rem !important;
    }
  }
</style>
